import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, isRef as _isRef } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_3 = {
  style: {
    "text-align": "right",
    "padding-top": "10px"
  }
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("保存");

import { computed, watch, ref, reactive } from 'vue';
import { getVexTableProps } from '@/config';
import { getActivityMerchandiseList } from '@/request';
export default {
  name: 'merchandise-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    suppliers: {
      type: Array,
      default: () => []
    },
    branches: {
      type: Array,
      default: () => []
    },
    publishType: {
      type: Number
    },
    selectedMerchandises: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const publisherTypes = {
      发货方: 1,
      控销团队: 2,
      平台: 3
    };
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const table = ref();
    watch(() => props.modelValue, v => {
      if (v) {
        var _table$value;

        form.branchIds = '';
        form.prodName = '';
        (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
      }
    });
    const form = reactive({
      branchIds: '',
      prodName: ''
    });
    const branchList = ref([]);
    const defaultSelecteRowKeys = computed(() => props.selectedMerchandises);
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '发货方',
        field: 'branchName'
      }, {
        title: '药品编码',
        field: 'prodNo'
      }, {
        title: '药品名称',
        field: 'prodName'
      }, {
        title: '药品规格',
        field: 'prodSpecification'
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            let params = _objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize
            }, form);

            if (props.publishType === publisherTypes['发货方'] && form.branchIds === '') {
              params.branchIds = props.branches.map(v => v.branchId).join();
            }

            if (props.publishType === publisherTypes['控销团队']) {
              params.supplierIds = props.suppliers.map(v => v.supplierId).join();
            }

            getActivityMerchandiseList(params).then(data => {
              if (props.publishType === publisherTypes['发货方']) {
                branchList.value = props.branches;
              } else {
                branchList.value = data.data.branchInfoList;
              }

              res({
                total: data.data.totalSize,
                result: data.data.activityMerchandiseList
              });
            });
          })
        }
      }
    });

    function submit() {
      let selectRows = table.value.getCheckboxRecords();
      visible.value = false;
      emit('success', selectRows);
    }

    function resetHandle() {
      form.branchIds = undefined;
      form.prodName = undefined;
      table.value.commitProxy('reload');
    }

    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "选择商品",
        width: "80%",
        top: "5vh"
      }, {
        footer: _withCtx(() => [_createElementVNode("footer", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "发货方"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.branchIds,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.branchIds = $event),
              placeholder: "全部",
              clearable: "",
              filterable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(branchList.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  value: item.branchId,
                  label: item.branchName,
                  key: item.branchId
                }, null, 8, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "药品名"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.prodName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.prodName = $event),
              placeholder: "请输入药品名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              icon: "Search",
              onClick: _cache[2] || (_cache[2] = $event => table.value.commitProxy('reload'))
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            }), _createVNode(_component_el_button, {
              type: "primary",
              icon: "Refresh",
              onClick: resetHandle
            }, {
              default: _withCtx(() => [_hoisted_2]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_grid, _mergeProps({
          ref_key: "table",
          ref: table
        }, _unref(tableOptions)), null, 16)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};